import React, { useState, useEffect } from "react";

import "./FilterFabricContent.css";
import { Fabric_Data } from "./Fabric_Data";

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import { Helmet } from 'react-helmet-async';
import Footer from "../../../CommonComponent/Footer/footer";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";

import { useParams } from "react-router-dom";


const FilterFabricContent = () => {
    const { ProductFabricId } = useParams();
    const product_fabricData = Fabric_Data[ProductFabricId];

    const Visibility = product_fabricData?.Visibility || null;
    const Colors = product_fabricData?.Colors || null;
    const Designs = product_fabricData?.Designs || null;
    const Series = product_fabricData?.Series || null;
    const imageData = product_fabricData?.FabricImages || [];
    const HeroImage = product_fabricData?.PGHeroImage || null;
    const ImgAspectRatio = product_fabricData?.ImgAspectRatio || null;
    const DD_PlaceHolder = product_fabricData?.DD_PlaceHolder || null;


    const NUM_COLUMNS = product_fabricData?.Num_of_col || 6;
    const ITEMS_PER_PAGE = product_fabricData?.Items_display || 24;

    const META_PG_Title = product_fabricData?.META_PG_Title || '';
    const META_PG_OG_Description = product_fabricData?.META_PG_OG_Description || 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.';
    const META_PG_Canonical_OG_URL = product_fabricData?.META_PG_Canonical_OG_URL || '';
    const OG_title = product_fabricData?.OG_title || null;


    const [filter1, setFilter1] = useState("");
    const [filter2, setFilter2] = useState("");
    const [filter3, setFilter3] = useState("");
    const [filter4, setFilter4] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const handleClearFilters = () => {
        setFilter1("");
        setFilter2("");
        setFilter3("");
        setFilter4("");
    };

    const filterImages = () => {
        return imageData.filter((img) => {
            if (!img.keywords && (filter1 || filter2 || filter3 || filter4)) return false;
            if (!filter1 && !filter2 && !filter3 && !filter4) return !!img.src;

            const keywordArray = img.keywords
                ? img.keywords.split(",").map((k) => k.trim().toLowerCase())
                : [];

            const match1 = filter1 ? keywordArray.includes(filter1.toLowerCase()) : true;
            const match2 = filter2 ? keywordArray.includes(filter2.toLowerCase()) : true;
            const match3 = filter3 ? keywordArray.includes(filter3.toLowerCase()) : true;
            const match4 = filter4 ? keywordArray.includes(filter4.toLowerCase()) : true;

            return match1 && match2 && match3 && match4 && !!img.src;
        });
    };

    const distributeImagesToColumns = (images, columnsCount) => {
        const columns = Array.from({ length: columnsCount }, () => []);
        images.forEach((img, idx) => {
            columns[idx % columnsCount].push(img);
        });
        return columns;
    };

    const filteredImages = filterImages();
    const totalPages = Math.ceil(filteredImages.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const paginatedImages = filteredImages.slice(startIndex, endIndex);
    const columns = distributeImagesToColumns(paginatedImages, NUM_COLUMNS);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            const target = document.getElementById("Filter_bar");
            if (target) {
                target.scrollIntoView({ behavior: "smooth" });
            }
        }
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [filter1, filter2, filter3, filter4]);

    return (
        <>

            <Helmet>
                {/* Primary SEO Tags */}
                <title>{META_PG_Title}</title>
                <meta
                    name="description"
                    content={META_PG_OG_Description}
                />
                <link rel="canonical" href={META_PG_Canonical_OG_URL} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content={OG_title} />
                <meta
                    property="og:description"
                    content={META_PG_OG_Description}
                />
                <meta property="og:url" content={META_PG_Canonical_OG_URL} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>


            <Navbar />
            <NotificationBar />
            {HeroImage != null && (
                <div className="fabric-filter-pg-heroImg">
                    <img src={HeroImage} alt="Hero" />
                </div>
            )}
            <div className="ff-pg">
                <div className="ff-gallery-container">
                    <div className="ff-filter-bar" id="Filter_bar">
                        {Visibility != null && (
                            <select
                                value={filter1}
                                onChange={(e) => setFilter1(e.target.value)}
                                className={`ff-filter-dropdown ff-filter-d1 ${(Series === null && Designs === null && Colors === null) ? "ff-filter-dd4" : ""}`}
                                name="Visibility"
                            >
                                <option value="">Visibility...</option>
                                {Visibility.map((opt, idx) => (
                                    <option key={idx} value={opt}>{opt}</option>
                                ))}
                            </select>
                        )}

                        {Colors != null && (
                            <select
                                value={filter2}
                                onChange={(e) => setFilter2(e.target.value)}
                                className={`ff-filter-dropdown ff-filter-d1 ${(Series === null && Designs === null) ? "ff-filter-dd4" : ""}`}
                                name="Color"
                            >
                                <option value="">Colors</option>
                                {Colors.map((opt, idx) => (
                                    <option key={idx} value={opt}>{opt}</option>
                                ))}
                            </select>
                        )}

                        {Designs != null && (
                            <select
                                value={filter3}
                                onChange={(e) => setFilter3(e.target.value)}
                                className={`ff-filter-dropdown ff-filter-d1 ${Series === null ? "ff-filter-dd4" : ""}`}
                                name="Designs"
                            >
                                <option value="">{DD_PlaceHolder === null ? "Designs" : DD_PlaceHolder}</option>
                                {Designs.map((opt, idx) => (
                                    <option key={idx} value={opt}>{opt}</option>
                                ))}
                            </select>
                        )}

                        {Series != null && (
                            <select
                                value={filter4}
                                onChange={(e) => setFilter4(e.target.value)}
                                className="ff-filter-dropdown ff-filter-dd4"
                                name="Series"
                            >
                                <option value="">Series</option>
                                {Series.map((opt, idx) => (
                                    <option key={idx} value={opt}>{opt}</option>
                                ))}
                            </select>
                        )}

                        {!(Visibility === null && Colors === null && Designs === null && Series === null) && (
                            <button onClick={handleClearFilters} className="ff-clear-button">
                                Clear All Filters
                            </button>
                        )}


                    </div>

                    {filteredImages.length > 0 ? (
                        <>
                            <div className="ff-gallery-flex">
                                {columns.map((col, colIdx) => (
                                    <div className="ff-flex-column" key={colIdx}>
                                        {col.map((img, idx) => (
                                            <div className="ff-gallery-item" key={idx}>
                                                <img src={img.src} alt={img.fabricName} className={`${ImgAspectRatio === null ? "" : "ImgAspectRatio"}`} />
                                                <h5>{img.fabricName}</h5>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>

                            {/* Pagination UI */}
                            {totalPages > 1 && (
                                <div className="ff-pagination-controls">

                                    <button className="ff-display_page_no">
                                        {"Page " + currentPage + " of " + totalPages}
                                    </button>
                                    {currentPage != 1 && (
                                        <button
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                            className="ff-pagination-navigator"
                                        >
                                            Prev
                                        </button>
                                    )}

                                    {currentPage != totalPages && (
                                        <button
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            className="ff-pagination-navigator"
                                        >
                                            Next
                                        </button>
                                    )}
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="ff-no-items-message">
                            <p>There are no items in that Selection.</p>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default FilterFabricContent;
